import { styled, Box } from '@mui/material'
import theme from 'lib/theme'

export const ResponsiveBoxWrapper = styled(Box, {
  shouldForwardProp: (props) => props !== 'showOverlay',
})<{ showOverlay: boolean }>(({ showOverlay }) => ({
  padding: showOverlay ? theme.spacing(2) : theme.spacing(4),
  paddingBottom: 0,
  flex: '0 1 100%',
  height: '100vh',
  overflowY: 'scroll',
  [theme.breakpoints.between('xs', 'sm')]: {
    width: '100vw',
    height: '100vh',
    overflowX: 'hidden',
    position: 'fixed',
    zIndex: 1,
    left: 0,
    top: 0,
    backgroundColor: theme.palette.commonColors.white,
    visibility: showOverlay ? 'visible' : 'hidden',
    borderLeft: 0,
  },
}))
